<template>
  <div>
    <orderdetail-cont :list="detailList" v-transition></orderdetail-cont>
  </div>
</template>

<script>
import OrderdetailCont from './components/Content'
export default {
  name: 'Orderdetail',
  components: {
    OrderdetailCont
  },
  data () {
    return {
      detailList: []
    }
  },
  methods: {
    getDetailInfo () {
      this.axios.get('/ApiOrderConfirm/GetSynthetic')
        .then(this.getDetailInfoSucc)
        .catch(this.getDetailInfoFail)
    },
    getDetailInfoSucc (res) {
      res = res.data
      if (res.ret) {
        const data = res.data
        this.detailList = JSON.parse(data.detailList)
      }
    },
    getDetailInfoFail () {
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getDetailInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/order_detail/Detail.vue